import React from 'react';

// user choices array gets passed in as a prop
// params = []
const Button = ({onClick, children, params = []}) => {
    const paramsCopy = [...params];
    const [firstArg, secondArg] = paramsCopy;
    
    return (
        <button type="submit" className="submitButton" onClick={ (e) => onClick(e, firstArg, secondArg
        )}
        
        >{children}</button>
    )
}

export default Button;